'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizer = undefined;
exports.default = entities;

var _lodash = require('lodash');

var _normalizr = require('normalizr');

var _schema = {
  outfeats: new _normalizr.Schema('outfeats')
};

var _normalizer = function _normalizer(type, data) {
  var _data = {};
  var _s = {};
  _s[type] = data.length ? (0, _normalizr.arrayOf)(_schema[type]) : _schema[type];
  _data[type] = data;
  var normalizedData = (0, _normalizr.normalize)(_data, _s);
  return normalizedData;
};
var normalizer = exports.normalizer = function normalizer(type, data) {
  if (typeof type === 'string') {
    return _normalizer(type, data);
  } else {
    return type.reduce(function (p, c) {
      if (data[c]) {
        return (0, _lodash.merge)(p, _normalizer(c, data[c]));
      }
      return p;
    }, {});
  }
};

var initialState = {
  outfeats: {}
};
function entities() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  if (action.result && action.result.entities) {
    return (0, _lodash.merge)({}, state, action.result.entities);
  }
  return state;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/entities.js
 ** module id = 134
 ** module chunks = 0
 **/